import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Legal.module.css';

export function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <article className={styles.page}>
      <header className={styles.header}>
        <Link to="/" className={styles.back}>{t('common.back')}</Link>
        <h1>{t('legal.privacyTitle')}</h1>
      </header>

      <div className={styles.content}>
        <p className={styles.updated}>{t('legal.lastUpdated')}</p>

        <section>
          <h2>{t('legal.privacy.collectTitle')}</h2>
          <p>{t('legal.privacy.collectBody')}</p>
        </section>

        <section>
          <h2>{t('legal.privacy.useTitle')}</h2>
          <p>{t('legal.privacy.useBody')}</p>
        </section>

        <section>
          <h2>{t('legal.privacy.shareTitle')}</h2>
          <p>{t('legal.privacy.shareBody')}</p>
        </section>

        <section>
          <h2>{t('legal.privacy.rightsTitle')}</h2>
          <p>{t('legal.privacy.rightsBody')}</p>
        </section>

        <aside className={styles.note}>{t('legal.legalNote')}</aside>
      </div>
    </article>
  );
}
